
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Main_Data_url","data-name":"Main Data url","transform":"translate(-101.151 -539.148)"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(101.151 539.148)","fill":"none"}}),_c('g',{attrs:{"id":"Group_29742","data-name":"Group 29742","transform":"translate(101.753 539.75)"}},[_c('g',{attrs:{"id":"Group_29744","data-name":"Group 29744","transform":"translate(.5 .5)"}},[_c('path',{attrs:{"id":"Path_20987","data-name":"Path 20987","d":"M6.018 0a6.018 6.018 0 106.018 6.018A6.019 6.019 0 006.018 0zm1.5 3.258c2.728-1.518 2.493-1.283 2.728-1.518m.683 7.772L9.6 8.182a.249.249 0 01-.073-.177v-.482a1.5 1.5 0 00-1.5-1.5H6.518a.5.5 0 01-.5-.5v-.257a.25.25 0 01.248-.252h0A1.254 1.254 0 007.522 3.76v-.5m-1 8.566v-1.723a1.5 1.5 0 00-1.5-1.5H3.676a.5.5 0 01-.355-.142L.031 5.4","fill":"none","stroke":"#96a0ae","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}})])])])])
          )
        }
      }
    